import chatbotRequest from '@/service/channel/http'
import type { RoomDetailReq, RoomDetailRes } from '../type/getRoomDetail'

export function getRoomDetailApi(data: RoomDetailReq): Promise<RoomDetailRes> {
    return chatbotRequest<RoomDetailRes, RoomDetailReq, RoomDetailRes>({
        url: '/api/room/detail',
        method: 'post',
        data,
    })
}
